
export const convertPriceToCents = (price) =>  parseFloat(price)*100;

export const convertCentsToPrice = (cents) => parseFloat(cents)/100;

